/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {SvgIconEl} from 'common/components/svg-icon';

import {AutoDocEl} from '../components/auto-doc';
import {CodeTipEl} from '../components/code-tip';
import type {DesignSystem} from '../index';
import {Section, SubSection} from './utils';

function iconPalette(icons) {
  return (
    <>
      <div sel='.example.block'>
        <div sel='.item-palette'>
          {icons.map((icon) => (
            <div sel='.list-block'>
              <SvgIconEl attrs={{icon}} />
              <div sel='.label'>{icon}</div>
            </div>
          ))}
        </div>
      </div>
      <br />
    </>
  );
}

export function IconographySection({designSystem}: {designSystem: DesignSystem}) {
  return (
    <Section title='Iconography'>
      <SubSection title='Icons'>
        <p sel='.desc'>
          All SVG icons should measure 16x16 px, saved with 3px of padding (to account for a possible ascenders and
          descenders) resulting in a 22x22 viewbox. If you need a different size in your application, you should use the
          "svg-icon-style" stylus mixin instead of saving a differently sized SVG file. You should also clean up SVG
          files by removing editor-specific XML and explicitly defined fill colors (stroke colors can be replaced by the
          keyword "currentColor").
        </p>

        <p sel='.desc'>
          Brand Icons should only be used in the top navigation, and we are in the process of removing them.
        </p>
        <p sel='.desc'>
          Other sections show logical groupings for existing icons. Some icons can and are used in multiple places, so
          you may see an icon show up in multiple sections. Note that any uncategorized icon will show up in the last
          section under 'Uncategorized'.
        </p>

        {designSystem.helpers.getIconSets().map((iconGroup) => (
          <>
            <h4>{iconGroup.name}</h4>
            {iconPalette(iconGroup.icons)}
          </>
        ))}

        <CodeTipEl sel='.example'>
          <SvgIconEl attrs={{icon: `bar-graph`}} />
        </CodeTipEl>
        <AutoDocEl attrs={{component: `svg-icon`}} />
      </SubSection>
    </Section>
  );
}
